import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes.js';
// import Vue2TouchEvents from 'vue2-touch-events';

// import ProgressBar from 'progressbar.js';
// import Recorder from 'recorder-js';
// import Recorder from '../node_modules/recorder/WebAudioRecorder.js'

import Harmony from './components/harmony.vue'; 

Vue.use(VueRouter);


Vue.component('Harmony', Harmony);


const router = new VueRouter({
	routes,
	mode: 'history'
});

// export const eventBus = new Vue();
// export const weatherStartupMobile = new Vue();

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js